import { Component, Schema, type, defaultValue } from "minecs";
@Component()
export class AirportZone extends Schema {
    @type("string")
    @defaultValue("work")
    kind: string;
    @type("number")
    @defaultValue(-1)
    stage: number;
    @type("number")
    @defaultValue(44)
    radius: number;
    @type("number")
    @defaultValue(0)
    gate: number;
}
